import { Texto } from '@gravitate-js/excalibrr'
import { clamp } from '@utils/general'
import { Col, Row } from 'antd'
import React from 'react'

type DestinationUpdatedProps = {
  oldCompartmentValues: string[]
  newCompartmentValues: string[]
  oldStopValues: string[]
  newStopValues: string[]
}

export function DestinationUpdated({
  oldCompartmentValues,
  newCompartmentValues,
  oldStopValues,
  newStopValues,
}: DestinationUpdatedProps) {
  const unitLength =
    oldCompartmentValues?.length > newCompartmentValues?.length
      ? oldCompartmentValues.length
      : newCompartmentValues.length

  const span = clamp(Math.floor(24 / unitLength), 2, 4)

  if (newCompartmentValues.length < unitLength) {
    while (newCompartmentValues.length < unitLength) {
      newCompartmentValues.push('')
    }
  } else if (oldCompartmentValues.length < unitLength) {
    while (oldCompartmentValues.length < unitLength) {
      oldCompartmentValues.push('')
    }
  }
  return (
    <div className='details-container pt-1'>
      <StopOrderRow version='PREV' oldStopValues={oldStopValues} newStopValues={newStopValues} />
      <StopOrderRow version='NEW' oldStopValues={oldStopValues} newStopValues={newStopValues} />
      <Row className='mb-3 mt-3 pt-4' justify='space-between'>
        <Texto align='center' weight='bold'>
          COMP
        </Texto>
        {newCompartmentValues.map((_, index) => (
          <Col span={span} key={crypto.randomUUID()}>
            <Texto align='right' weight='bold'>
              {index + 1}
            </Texto>
          </Col>
        ))}
      </Row>
      <CompartmentOrderRow
        version='PREV'
        oldCompartmentValues={oldCompartmentValues}
        newCompartmentValues={newCompartmentValues}
        span={span}
      />
      <CompartmentOrderRow
        version='NEW'
        oldCompartmentValues={oldCompartmentValues}
        newCompartmentValues={newCompartmentValues}
        span={span}
      />
    </div>
  )
}

type StopOrderRowProps = {
  oldStopValues: string[]
  newStopValues: string[]
  version: 'NEW' | 'PREV'
}
function StopOrderRow({ oldStopValues, newStopValues, version }: StopOrderRowProps) {
  const stopValues = version === 'PREV' ? oldStopValues : newStopValues
  return (
    <Col className='mb-3 mt-3 pt-4'>
      <Texto style={{ marginBottom: '4px' }} weight='bold'>
        {version} STOP ORDER
      </Texto>
      <Row justify='space-between'>
        {(stopValues || []).map((name, i) => (
          <Texto
            key={crypto.randomUUID()}
            category={version === 'PREV' ? 'p1' : 'label'}
            align='center'
            appearance={name !== oldStopValues[i] && version === 'NEW' ? 'secondary' : 'default'}
            weight={name !== oldStopValues[i] && version === 'NEW' && 'bold'}
          >
            {name}
          </Texto>
        ))}
      </Row>
    </Col>
  )
}

type CompartmentOrderRowProps = {
  oldCompartmentValues: string[]
  newCompartmentValues: string[]
  version: 'NEW' | 'PREV'
  span: number
}
function CompartmentOrderRow({ oldCompartmentValues, newCompartmentValues, version, span }: CompartmentOrderRowProps) {
  const compartmentValues = version === 'PREV' ? oldCompartmentValues : newCompartmentValues
  return (
    <Row className='mb-3' justify='space-between'>
      <Texto weight='bold' style={{ marginRight: '7px' }}>
        DEST
      </Texto>
      {compartmentValues.map((compartment, index) => (
        <Col span={span} key={crypto.randomUUID()}>
          <Texto
            category={version === 'PREV' ? 'p1' : 'label'}
            align='right'
            appearance={compartment !== oldCompartmentValues[index] && version === 'NEW' ? 'secondary' : 'default'}
            weight={compartment !== oldCompartmentValues[index] && version === 'NEW' && 'bold'}
          >
            {compartment}
          </Texto>
        </Col>
      ))}
    </Row>
  )
}
